import { connect } from 'react-redux'
import * as UserActions from '../stores/user/actions';
import * as NavigationActions from '../stores/navigation/actions';
import * as TackNotificationsActions from '../stores/tack_notifications/actions';
import * as PeopleNotificationsActions from '../stores/people_notifications/actions';
import * as IntraAppMessagingReceiverActions from '../stores/intra_app_messaging_receiver/actions';
import IntraAppMessagingService from '../services/intra_app_messaging_service';
import AppComponent from '../components/app';

const mapStateToProps = (state) => {
  return {
    user: state.default.user,
    tackNotifications: state.default.tackNotifications,
    peopleNotifications: state.default.peopleNotifications,
    navigation: state.default.navigation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLoginIfAuthToken: () => {
      dispatch(UserActions.loginIfAuthToken());
    },
    onLogout: () => {
      dispatch(UserActions.logout());
    },
    onSetPath: (pathname, scrollY) => {
      dispatch(NavigationActions.setPath(pathname, scrollY));
    },
    onRetrieveTackNotificationsUnreadCount: () => {
      dispatch(TackNotificationsActions.unreadCount());
    },
    onRetrievePeopleNotificationsUnreadCount: () => {
      dispatch(PeopleNotificationsActions.unreadCount());
    },
    onSyncUnreadNotificationCountWithMobileApp: (unreadNotificationCount) => {
      IntraAppMessagingService.shareUnreadNotificationCount(unreadNotificationCount);
    },
    onProcessMobileAppMessage: (messageEvent, loggedIn) => {
      dispatch(IntraAppMessagingReceiverActions.processMessageFromMobileApp(messageEvent, loggedIn));
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AppComponent);



// WEBPACK FOOTER //
// ./src/containers/app.js